<script>
import { ArrowUpIcon,
  ZoomInIcon,
  FileIcon,
  ApertureIcon,
  UploadIcon,
  VideoIcon,
  DownloadIcon,
  Share2Icon,
  MonitorIcon } from "vue-feather-icons";
import { Carousel, Slide } from "vue-carousel";

import Navbar from "@/components/navbar";
import Testimonial from "@/components/testimonial";
import Footer from "@/components/footer";
import Pricing from "@/components/pricing2";
import config from "@/config.json";
import axios from 'axios';
import Vue from "vue";

/**
 * Index-saas component
 */
export default {
  data() {
    return {
      playing: false,
      showCompany: false,
      pause: false,
      lang: this.getLang(),
      follow: "wechat"
    };
  },
  mounted() {
    this.showCompany = (/designmirror/.test(location.host));
    console.log(`lang: ${this.lang}`);
  },
  methods: {
    play() {
      this.playing = true;
      this.pause = false;
      this.$nextTick(() => {
        this.$refs.player.play();
      });
      _czc.push(["_trackEvent", "video", "play"]);
    },
    togglePlay() {
      this.pause = !this.pause;
      this.$nextTick(() => {
        if (this.$refs.player.paused) {
          this.$refs.player.play();
        } else {
          this.$refs.player.pause();
        }
      });
    },
    showFollowModal(name) {
      this.follow = name;
      this.$bvModal.show("follow-modal");
    }
  },
  components: {
    Carousel,
    Slide,
    Navbar,
    Testimonial,
    Footer,
    Pricing,
    ArrowUpIcon,
    MonitorIcon,
    ZoomInIcon,
    FileIcon,
    ApertureIcon,
    UploadIcon,
    DownloadIcon,
    Share2Icon,
    VideoIcon,
  },
};
</script>

<template>
  <div>
    <Navbar />

    <!-- Hero Start -->
    <section class="bg-home d-flex align-items-center" style="
        background: url('images/saas/home-shape.png') center center;
        height: auto;
      "id="home">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12 text-center mt-0 mt-md-5 pt-0 pt-md-5">
            <div class="title-heading margin-top-100">
              <h1 class="heading mb-3">{{$t('index.title')}}</h1>
              <p class="para-desc mx-auto">{{$t('index.description')}} </p>
            </div>

            <div class="row justify-content-center mt-4">
              <div class="col-9 text-center">
                <div
                    class="video-solution-cta position-relative"
                    style="z-index: 1"
                >
                  <div class="position-relative">
                    <video @click="togglePlay" v-if="playing" ref="player" src="https://mirror-web.oss-cn-shanghai.aliyuncs.com/video/designmirror-show1.mp4"></video>
                    <img v-else src="images/index/video-cover1.png" class="img-fluid" alt="" />
                    <div v-if="!playing || pause" class="play-icon">
                      <a href="#" @click.prevent="play" class="play-btn video-play-icon" >
                        <i class="mdi mdi-play text-primary rounded-circle bg-white shadow-lg" ></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <!--end col-->
            </div>
            <!--end row -->

          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Hero End -->

    <!-- Feature Start -->
    <section class="section bg-light mt-0 mt-lg-5">
      <div class="container">
        <div class="row">
          <div class="col-md-3 col-12">
            <div class="features">
              <div class="image position-relative d-inline-block">
                <img src="images/index/photoshop.png" width="50" alt="photoshop"/>
              </div>

              <div class="content mt-4">
                <h5>Photoshop</h5>
                <p class="mb-0">{{$t('index.photoshop')}}</p>
              </div>
            </div>
          </div><!--end col-->

          <div class="col-md-3 col-12 mt-5 mt-sm-0">
            <div class="features">
              <div class="image position-relative d-inline-block">
                <img src="images/index/xd.png" width="50" alt="xd"/>
              </div>

              <div class="content mt-4">
                <h5>Adobe XD</h5>
                <p class="mb-0">{{$t('index.xd')}}</p>
              </div>
            </div>
          </div><!--end col-->

          <div class="col-md-3 col-12 mt-5 mt-sm-0">
            <div class="features">
              <div class="image position-relative d-inline-block">
                <img src="images/index/sketch.png" width="50" alt="sketch"/>
              </div>

              <div class="content mt-4">
                <h5>Sketch</h5>
                <p class="mb-0">{{$t('index.sketch')}}</p>
              </div>
            </div>
          </div><!--end col-->


          <div class="col-md-3 col-12 mt-5 mt-sm-0">
            <div class="features">
              <div class="image position-relative d-inline-block">
                <img src="images/index/figma.png" width="50" alt="figma"/>
              </div>

              <div class="content mt-4">
                <h5>Figma</h5>
                <p class="mb-0">{{$t('index.figma')}}</p>
              </div>
            </div>
          </div><!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->

      <div class="container mt-100 mt-60">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-6">
            <img src="images/index/index-feature-1.png" class="img-fluid" alt="" />
          </div>
          <!--end col-->

          <div class="col-lg-6 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <div class="section-title ml-lg-5">
              <h4 class="title mb-4"> {{$t('index.feature1.title')}} </h4>
              <p> {{$t('index.feature1.description')}} </p>
              <ul class="list-unstyled">
                <li class="mb-0" v-for="item in $t('index.feature1.details')">
                  <span class="text-primary h5 mr-2"><i class="uil uil-check-circle align-middle"></i></span>
                  {{item}}
                </li>
              </ul>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->

      <div class="container mt-100 mt-60">
        <div class="row align-items-center">
          <div
            class="col-lg-7 col-md-6 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0"
          >
            <div class="section-title mr-lg-5">
              <h4 class="title mb-4">{{$t('index.feature2.title')}}</h4>
              <p> {{$t('index.feature2.description')}} </p>
              <ul class="list-unstyled">
                <li class="mb-0" v-for="item in $t('index.feature2.details')">
                  <span class="text-primary h5 mr-2"><i class="uil uil-check-circle align-middle"></i></span> {{item}}
                </li>
              </ul>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-5 col-md-6 order-1 order-md-2">
            <img class="img-fluid" src="images/index/index-feature-2.png" alt="" />
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->


      <div class="container mt-100 mt-60">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-6">
            <img src="images/index/index-feature-3.png" class="img-fluid" alt="" />
          </div>
          <!--end col-->

          <div class="col-lg-6 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <div class="section-title ml-lg-5">
              <h4 class="title mb-4"> {{$t('index.feature3.title')}} </h4>
              <p> {{$t('index.feature3.description')}} </p>
              <ul class="list-unstyled">
                <li class="mb-0" v-for="item in $t('index.feature3.details')">
                  <span class="text-primary h5 mr-2"><i class="uil uil-check-circle align-middle"></i></span>
                  {{item}}
                </li>
              </ul>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->



      <!-- Features Start -->
      <section class="section bg-light">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 text-center">
              <div class="section-title mb-4 pb-2">
                <h4 class="title mb-4">{{$t('index.app.title')}}</h4>
                <p class="para-desc mb-0 mx-auto">
                  {{$t('index.app.description')}}
                </p>
              </div>
            </div>
            <!--end col-->
          </div>
          <!--end row-->

          <div class="row justify-content-center align-items-center">
            <div class="col-lg-8 col-md-8">
              <div class="row mt-4 pt-2">
                <div class="col-md-6 col-12" v-for="(item, index) in $t('index.app.features')">
                  <div class="media features pt-4 pb-4">
                    <div class="icon text-center rounded-circle text-primary mr-3 mt-2">
                      <zoom-in-icon v-if="index === 0" class="fea icon-ex-md text-primary"></zoom-in-icon>
                      <file-icon v-if="index === 1" class="fea icon-ex-md text-primary"></file-icon>
                      <aperture-icon v-if="index === 2" class="fea icon-ex-md text-primary"></aperture-icon>
                      <upload-icon v-if="index === 3" class="fea icon-ex-md text-primary"></upload-icon>
                      <download-icon v-if="index === 4" class="fea icon-ex-md text-primary"></download-icon>
                      <share2-icon v-if="index === 5" class="fea icon-ex-md text-primary"></share2-icon>
                    </div>
                    <div class="media-body">
                      <h4 class="title">{{item.title}}</h4>
                      <p class="para mb-0">
                        {{item.description}}
                      </p>
                    </div>
                  </div>
                </div>
                <!--end col-->
              </div>
              <!--end row-->
            </div>
            <!--end col-->

            <div class="col-lg-4 col-md-4 col-12 mt-4 pt-2 text-center text-md-right" >
              <img src="images/index/index-feature-4.png" class="img-fluid" alt="" />
            </div>
            <!--end col-->
          </div>
          <!--end row-->
        </div>
        <!--end container-->
      </section>
      <!--end section-->
      <!-- Feature End -->

      <!-- Price Start -->
      <section class="section" v-if="!showCompany">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 text-center">
              <div class="section-title mb-4 pb-2">
                <h4 class="title mb-4">{{$t('index.price.title')}}</h4>
                <p class="para-desc mb-0 mx-auto">
                  {{$t('index.price.description')}}
                </p>
              </div>
            </div>
            <!--end col-->
          </div>
          <!--end row-->

          <Pricing :pricing-data="$t('index.price.plans')"/>
        </div>
        <!--end container-->
      </section>
      <!--end section-->
      <!-- Price End -->

      <div class="container pb-lg-4 mb-md-5 mb-4 mt-60">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title">
              <h4 class="title mb-4"> {{$t('index.contact.title')}} </h4>
              <p class="para-desc mx-auto mb-0"> {{$t("index.contact.description")}} </p>

              <div class="row mt-4 text-left">
                <div class="col-md-6 mt-4" v-for="(item, index) in $t('index.contact.details')">
                  <div class="media features feature-clean core-feature rounded shadow p-4">
                    <div class="icons text-primary text-center mx-auto" v-if="lang === 'zh'">
                      <span class="d-block rounded h3 mb-0" v-if="index === 0">
                        <font-awesome-icon :icon="['fab', 'weixin']"></font-awesome-icon>
                      </span>
                      <span class="d-block rounded h3 mb-0" v-if="index === 1">
                        <font-awesome-icon :icon="['fab', 'weixin']"></font-awesome-icon>
                      </span>
                      <span class="d-block rounded h3 mb-0" v-if="index === 2">
                        <font-awesome-icon :icon="['fas', 'comments']"></font-awesome-icon>
                      </span>
                      <span class="d-block rounded h3 mb-0" v-if="index === 3">
                        <font-awesome-icon :icon="['fab', 'qq']"></font-awesome-icon>
                      </span>
                    </div>
                    <div class="icons text-primary text-center mx-auto" v-if="lang === 'en'">
                      <span class="d-block rounded h3 mb-0" v-if="index === 0">
                        <font-awesome-icon :icon="['fab', 'slack']"></font-awesome-icon>
                      </span>
                      <span class="d-block rounded h3 mb-0" v-if="index === 1">
                        <font-awesome-icon :icon="['fab', 'twitter']"></font-awesome-icon>
                      </span>
                    </div>
                    <div class="media-body ml-4">
                      <h5 class="title text-dark">{{item.title}}</h5>
                      <p class="mt-2 mb-0">{{item.description}}</p>
                      <div class="text-primary" v-if="item.more" v-html="item.more"></div>
                      <a v-if="item.follow" class="text-primary" href="#" @click.prevent="showFollowModal(item.name)">{{item.follow}}</a>
                    </div>
                  </div>
                </div><!--end col-->

                <b-modal id="follow-modal" size="sm" ref="login-modal" hide-footer
                         :title="$t('index.contact.follow_title')"
                         header-close-variant="white"
                         no-close-on-backdrop
                         header-class="border-0"
                         content-class="border-0" centered >
                  <div v-if="follow==='wechat'"><img src="images/index/wechat-qrcode.png" class="img-fluid" alt=""></div>
                  <div v-if="follow==='qq'"><img src="images/index/qq-group-qrcode.png" class="img-fluid" alt=""></div>
                </b-modal>

              </div><!--end row-->
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end sectipn-->

    <Footer />
    <!-- Footer End -->
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>
